import React, { useContext } from 'react';
import { userData } from '../utils/userDataToAmplitude';
import { AuthContext, TrackEventContext, UtmContext, GeoContext } from '../context';
import { trackAmplitudeEvent } from '../utils/analytics';
import * as styles from './SocialLink.module.scss';

const FACEBOOK_TYPE = 'Facebook';
const TWITTER_TYPE = 'Twitter';
const LINKEDIN_TYPE = 'LinkedIn';
const GOOGLE_PLUS_TYPE = 'Google';
const INSTAGRAM_TYPE = 'Instagram';
const TIKTOK_TYPE = 'TikTok';
const CUSTOM_TYPE = 'Custom';

export const SocialLink = props => {
  const { resource: user } = useContext(AuthContext) || {};
  const { trackIntercomEvent, intercomId } = useContext(TrackEventContext) || {};
  const { utmParams } = useContext(UtmContext) || {};
  const { countryName: countryOfResidence } = useContext(GeoContext) || {};
  const { intercomAttributes, intercomEmail } = useContext(TrackEventContext) || {};

  const { utmSource, utmMedium, utmCampaign } = utmParams || {};

  const { type, url, event, pathName, userEmail, area, theme = 'primary', size = 'small' } = props;

  const onSocialShareClick = () => {
    if (user?.email || intercomId) {
      try {
        trackIntercomEvent({
          intercomId,
          email: user?.email || userEmail,
          eventName: `Social Share Button Clicked`,
          metadata: { deal: event, PageLocation: area, path: pathName, socialLink: type },
        });
      } catch (trackSocialLinkClickedIntercomErr) {
        console.error('Intercom event Social Share Link Clicked failed', {
          error: trackSocialLinkClickedIntercomErr,
        });
      }
    }

    const utilsUserData = userData(user);
    const userDataToAmp = {
      ...utilsUserData,
      country: countryOfResidence,
      firstName: user?.firstName,
      lastName: user?.lastName,
      source: utmSource,
      medium: utmMedium,
      campaign: utmCampaign,
    };

    try {
      trackAmplitudeEvent({
        email: user?.email || userEmail || intercomEmail,
        eventName: `Social Share Button Clicked`,
        eventData: { deal: event, PageLocation: area, path: pathName, socialLink: type },
        userData: user?.email ? userDataToAmp : intercomAttributes || {},
      });
    } catch (trackSocialLinkClickedAmplitudeErr) {
      console.error('form submission track amplitude error', {
        error: trackSocialLinkClickedAmplitudeErr,
      });
    }
  };

  if (!type) return null;
  const typeClass = type.replace(/_/g, '-');
  switch (type) {
    case FACEBOOK_TYPE:
      return (
        <a
          className={`${styles.socialLink} ${styles[typeClass]} ${styles[theme]} ${styles[size]}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onSocialShareClick(type)}
        >
          <svg className={styles.svg} viewBox="0 0 30 30">
            <g className={styles.g} transform="translate(-1.000000, -1.000000)">
              <path
                d="M28.9,1.5 L3.1,1.5 C2.2163444,1.5 1.5,2.2163444 1.5,3.1 L1.5,28.9 C1.5,29.7836556 2.2163444,30.5 3.1,30.5 L17,30.5 L17,19.285 L13.225,19.285 L13.225,14.895 L17,14.895 L17,11.665 C17,7.92 19.29,5.88 22.63,5.88 C23.7555369,5.87754542 24.8804239,5.93429046 26,6.05 L26,9.965 L23.7,9.965 C21.88,9.965 21.525,10.825 21.525,12.095 L21.525,14.89 L25.875,14.89 L25.31,19.28 L21.5,19.28 L21.5,30.5 L28.9,30.5 C29.7836556,30.5 30.5,29.7836556 30.5,28.9 L30.5,3.1 C30.5,2.2163444 29.7836556,1.5 28.9,1.5 Z"
                id="Icon"
              />
            </g>
          </svg>
        </a>
      );
    case TWITTER_TYPE:
      return (
        <a
          className={`${styles.socialLink} ${styles[typeClass]} ${styles[theme]} ${styles[size]}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onSocialShareClick(type)}
        >
          <svg className={styles.svg} viewBox="0 0 32 26">
            <g className={styles.g} transform="translate(0.000000, -3.000000)">
              <path
                d="M10.2378952,28.7175836 C21.9357743,28.7175836 28.3367347,19.0169033 28.3367347,10.618744 C28.3367347,10.3458349 28.3367347,10.0729257 28.3243297,9.80001656 C29.5648259,8.9068593 30.6440576,7.77800775 31.5,6.50029667 C30.3587435,7.00890011 29.1306523,7.34383409 27.8405362,7.50509859 C29.1554622,6.72358599 30.1602641,5.47068483 30.6440576,3.98208939 C29.4159664,4.71398214 28.0514206,5.23499055 26.60004,5.52030467 C25.4339736,4.27980848 23.7841136,3.51070083 21.9605842,3.51070083 C18.44998,3.51070083 15.5968387,6.36384209 15.5968387,9.87444633 C15.5968387,10.3706448 15.6588635,10.8544383 15.7581032,11.3258269 C10.4735894,11.0653227 5.78451381,8.52230547 2.64605842,4.67676726 C2.1002401,5.61954437 1.79011605,6.71118102 1.79011605,7.87724745 C1.79011605,10.0853307 2.91896759,12.0329097 4.61844738,13.1741662 C3.57643057,13.1369513 2.59643858,12.8516372 1.7404962,12.3802487 C1.7404962,12.4050586 1.7404962,12.4298685 1.7404962,12.4670834 C1.7404962,15.543514 3.93617447,18.1237461 6.83893557,18.7067793 C6.30552221,18.8556388 5.74729892,18.9300686 5.16426571,18.9300686 C4.75490196,18.9300686 4.35794318,18.8928537 3.97338936,18.8184239 C4.77971188,21.3490362 7.13665466,23.1849705 9.91536615,23.2345904 C7.73209284,24.9464751 4.99059624,25.963682 2.01340536,25.963682 C1.50480192,25.963682 0.996198479,25.9388721 0.5,25.8768473 C3.30352141,27.6631618 6.65286114,28.7175836 10.2378952,28.7175836"
                id="Icon"
              />
            </g>
          </svg>
        </a>
      );
    case INSTAGRAM_TYPE:
      return (
        <a
          className={`${styles.socialLink} ${styles[typeClass]} ${styles[theme]} ${styles[size]}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onSocialShareClick(type)}
        >
          <svg className={styles.svg} viewBox="0 0 16 16">
            <g className={styles.g}>
              <path
                d="M4.6653646,0 C2.09269793,0 0,2.0946354 0,4.66796867 L0,11.3346353 C0,13.907302 2.0946354,16 4.66796867,16 L11.3346353,16 C13.907302,16 16,13.9053647 16,11.3320313 L16,4.6653646 C16,2.09269793 13.9053647,0 11.3320313,0 L4.6653646,0 Z M12.6666667,2.66666667 C13.0346667,2.66666667 13.3333333,2.96533333 13.3333333,3.33333333 C13.3333333,3.70133333 13.0346667,4 12.6666667,4 C12.2986667,4 12,3.70133333 12,3.33333333 C12,2.96533333 12.2986667,2.66666667 12.6666667,2.66666667 Z M8,4 C10.206,4 12,5.794 12,8 C12,10.206 10.206,12 8,12 C5.794,12 4,10.206 4,8 C4,5.794 5.794,4 8,4 Z M8,5.33333333 C6.52724067,5.33333333 5.33333333,6.52724067 5.33333333,8 C5.33333333,9.47275933 6.52724067,10.6666667 8,10.6666667 C9.47275933,10.6666667 10.6666667,9.47275933 10.6666667,8 C10.6666667,6.52724067 9.47275933,5.33333333 8,5.33333333 Z"
                id="Shape"
              />
            </g>
          </svg>
        </a>
      );
    case LINKEDIN_TYPE:
      return (
        <a
          className={`${styles.socialLink} ${styles[typeClass]} ${styles[theme]} ${styles[size]}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onSocialShareClick(type)}
        >
          <svg className={styles.svg} viewBox="0 0 30 30">
            <g className={styles.g} fillRule="evenodd">
              <g className={styles.g} transform="translate(-1.000000, -1.000000)">
                <path
                  d="M26.2125951,26.2112222 L21.9123007,26.2112222 L21.9123007,19.48 C21.9123007,17.8753333 21.8832991,15.8115 19.6759542,15.8115 C17.4396078,15.8115 17.0980332,17.5611667 17.0980332,19.3656111 L17.0980332,26.2112222 L12.8009612,26.2112222 L12.8009612,12.3717778 L16.9224124,12.3717778 L16.9224124,14.2632222 L16.9820268,14.2632222 C17.5572254,13.1757222 18.9589699,12.0286111 21.0519196,12.0286111 C25.408606,12.0286111 26.2125951,14.8931667 26.2125951,18.6212778 L26.2125951,26.2112222 Z M7.95124729,10.4819444 C6.56883716,10.4819444 5.45388633,9.36383333 5.45388633,7.98633333 C5.45388633,6.61044444 6.56883716,5.49233333 7.95124729,5.49233333 C9.32560142,5.49233333 10.4437747,6.61044444 10.4437747,7.98633333 C10.4437747,9.36383333 9.32560142,10.4819444 7.95124729,10.4819444 Z M5.79546086,26.2112222 L10.1022001,26.2112222 L10.1022001,12.3717778 L5.79546086,12.3717778 L5.79546086,26.2112222 Z M28.3538808,1.5 L3.63806323,1.5 C2.45866437,1.5 1.5,2.43605556 1.5,3.59122222 L1.5,28.4071667 C1.5,29.5623333 2.45866437,30.5 3.63806323,30.5 L28.3538808,30.5 C29.536502,30.5 30.5,29.5623333 30.5,28.4071667 L30.5,3.59122222 C30.5,2.43605556 29.536502,1.5 28.3538808,1.5 Z"
                  id="Icon"
                />
              </g>
            </g>
          </svg>
        </a>
      );
    case GOOGLE_PLUS_TYPE:
      return (
        <a
          className={`${styles.socialLink} ${styles[typeClass]} ${styles[theme]} ${styles[size]}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onSocialShareClick(type)}
        >
          <svg className={styles.svg} viewBox="0 0 22 14">
            <g className={styles.g}>
              <path d="M7.656 8.46h3.41a4.338 4.338 0 0 1-4.117 2.89 4.344 4.344 0 0 1-4.296-4.16 4.336 4.336 0 0 1 4.328-4.502c1.118 0 2.138.426 2.908 1.124a.47.47 0 0 0 .638-.003l1.253-1.178a.468.468 0 0 0 0-.68A6.956 6.956 0 0 0 7.12.038C3.271-.036.027 3.12 0 6.97a6.981 6.981 0 0 0 13.95.443c.006-.047.01-1.603.01-1.603H7.656a.468.468 0 0 0-.468.468v1.714c0 .259.21.468.468.468M20.045 5.955v-1.57A.384.384 0 0 0 19.661 4h-1.322a.384.384 0 0 0-.384.384v1.57h-1.57A.384.384 0 0 0 16 6.34v1.322c0 .212.172.384.384.384h1.57v1.57c0 .213.173.385.385.385h1.322a.384.384 0 0 0 .384-.384v-1.57h1.57A.384.384 0 0 0 22 7.66V6.339a.384.384 0 0 0-.384-.384h-1.57z" />
            </g>
          </svg>
        </a>
      );
    case TIKTOK_TYPE:
      return (
        <a
          className={`${styles.socialLink} ${styles[typeClass]} ${styles[theme]} ${styles[size]}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onSocialShareClick(type)}
        >
          <svg className={styles.svg} viewBox="0 0 512 512" id="icons">
            <path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z" />
          </svg>
        </a>
      );
    case CUSTOM_TYPE:
      return (
        <a
          className={`${styles.socialLink} ${styles[typeClass]} ${styles[theme]} ${styles[size]}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onSocialShareClick(type)}
        >
          <svg className={styles.svg} viewBox="0 0 26 26">
            <g className={styles.g} transform="translate(-3.000000, -3.000000)">
              <path
                d="M22.4476886,3.50656717 C20.8623786,3.58256128 19.3378959,4.27410824 18.1593674,5.45201656 L13.5364964,10.0724589 C14.2626219,9.34291535 16.9580292,9.84447652 17.6119221,10.4980259 L20.4099757,7.70144242 C21.0296535,7.08209013 21.805201,6.70211954 22.5997567,6.66792243 C23.139599,6.64132425 23.9037411,6.75531591 24.5766423,7.4278636 C25.2039231,8.05481482 25.336983,8.78435835 25.336983,9.28212006 C25.336983,10.1142559 24.9568127,10.9425913 24.3029197,11.5923412 L19.4367397,16.4863623 C18.2125917,17.7098681 16.3497567,17.80866 15.270073,16.7295435 C14.6541976,16.1139917 13.6391426,16.1101912 13.0194647,16.7295435 C12.3997869,17.3488958 12.3997869,18.3596171 13.0194647,18.9789694 C14.129562,20.0884835 15.5894161,20.65084 17.0948905,20.65084 C18.7220195,20.65084 20.3833635,19.9858912 21.6569343,18.7053906 L26.553528,13.8417671 C27.7966852,12.6030635 28.5,10.9463917 28.5,9.28212006 C28.5,7.73563953 27.9145382,6.2651541 26.8272506,5.17843774 C25.6639299,4.01572824 24.1014297,3.43057305 22.4476886,3.50656717 Z M14.9051095,11.34916 C13.2779805,11.34916 11.5900243,12.0179083 10.3126521,13.2946094 L5.44647202,18.1582329 C4.20331484,19.3969375 3.5,21.0536093 3.5,22.7178799 C3.5,24.2643605 4.08546277,25.7348469 5.17274939,26.8215623 C6.33607105,27.9842727 7.89857032,28.5694269 9.55231144,28.4934328 C11.1376214,28.4174387 12.6621051,27.7258927 13.8406326,26.5479834 L18.4635036,21.9275411 C17.7335766,22.6570846 15.0419708,22.1555235 14.3880779,21.5019741 L11.5900243,24.2985576 C10.9703465,24.9179099 10.194799,25.294081 9.40024331,25.3320776 C8.86040195,25.3586757 8.09625888,25.2446841 7.42335766,24.5721364 C6.79607689,23.9451852 6.66301703,23.2118422 6.66301703,22.7178799 C6.66301703,21.8857441 7.04318735,21.0574087 7.69708029,20.4076588 L12.5632603,15.5136376 C13.7874092,14.2901329 15.6502433,14.1951395 16.729927,15.2704565 C17.3496049,15.8898088 18.3646599,15.8898088 18.9805353,15.2704565 C19.6002131,14.6511042 19.6002131,13.6403829 18.9805353,13.0210306 C17.870438,11.9115165 16.4067825,11.34916 14.9051095,11.34916 Z"
                id="Icon"
              />
            </g>
          </svg>
        </a>
      );
    default:
      return null;
  }
};
